import { format as dfFormat } from "date-fns";
import { cs } from "date-fns/locale";

const LOCALE = "cs-CZ" as const;
const DATE_LOCALE = cs;

/**
 * Formátování data s date-fns (s českým locale).
 * Použij pro custom patterny (např. "dd.MM.yyyy", "HH:mm").
 */
export const formatDate = (date: Date | number, pattern: string): string =>
  dfFormat(date, pattern, { locale: DATE_LOCALE });

/**
 * Standardní české krátké datum (např. 26. 5. 2026).
 */
export const formatDateShort = (date: Date | number): string => new Date(date).toLocaleDateString(LOCALE);

/**
 * Standardní český čas (např. 14:23:05).
 */
export const formatTime = (date: Date | number): string => new Date(date).toLocaleTimeString(LOCALE);

/**
 * Datum + čas dohromady (např. 26. 5. 2026 14:23:05).
 */
export const formatDateTime = (date: Date | number): string => new Date(date).toLocaleString(LOCALE);

/**
 * České číslo s oddělovači tisíců a desetinnou čárkou.
 * Např. 1234.5 → "1 234,5".
 */
export const formatNumber = (value: number, options?: Intl.NumberFormatOptions): string =>
  value.toLocaleString(LOCALE, options);

/**
 * České desetinné číslo s pevným počtem desetinných míst (čárka jako oddělovač).
 * Náhrada za `.toFixed(n)` v UI. Např. 12.3 + decimals=2 → "12,30".
 */
export const formatDecimal = (value: number, decimals: number): string =>
  value.toLocaleString(LOCALE, { minimumFractionDigits: decimals, maximumFractionDigits: decimals });
